import { render, staticRenderFns } from "./Errors.vue?vue&type=template&id=45dd1fd4&"
import script from "./Errors.vue?vue&type=script&lang=js&"
export * from "./Errors.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/www/html/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('45dd1fd4')) {
      api.createRecord('45dd1fd4', component.options)
    } else {
      api.reload('45dd1fd4', component.options)
    }
    module.hot.accept("./Errors.vue?vue&type=template&id=45dd1fd4&", function () {
      api.rerender('45dd1fd4', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/js/components/Errors.vue"
export default component.exports